<template>
  <v-dialog :value="value" persistent @click:outside="close" width="1100">
    <v-card>
      <div class="px-6 py-4">
        <h4 class="title">Все данные</h4>
        <v-btn absolute right icon small top @click="close">
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <v-row>
          <v-col sm="6" cols="12">
            <div class="list-data-item">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle >Имя</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.first_name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Фамилия</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.last_name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Отчество</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.middle_name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Пол</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.gender|genderParse}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Область</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.region}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Район</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.district}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Дата рождения</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.birth_day|parseDate}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Место рождения</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.birth_address}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>ИНН</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.inn}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>pnfl</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.pnfl}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Номер телефона</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">
                    <p class="ma-0">{{data.phone}}</p>
                    <div v-if="data.phones">
                      <p v-for="(phone,phoneIndex) in data.phones" :key="`phone-${phoneIndex}`">{{phone}}</p>
                    </div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Адрес по паспорту</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.passport_address}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Адрес проживания</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.live_address}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Серия паспорта</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.passport_series}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Номер паспорта</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.passport_number}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Дата получения паспорта</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.passport_issue_date|parseDate}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Срок годности паспорта</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.passport_expiry_date|parseDate}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-col>
          <v-col sm="6" cols="12">
            <div class="list-data-item">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Мко</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.mko}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Карта</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.card_pin}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Сумма</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.amount|money}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="data.initial_payment">
                <v-list-item-content>
                  <v-list-item-subtitle>Первоначальный взнос</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.initial_payment|money}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Вид платежа</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.payment_type|parsePaymentType}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Процент</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.percent}}%</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Дата начала</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.start_date |parseDate}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Дата окончания</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.finish_date|parseDate}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Тариф</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.tariff}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Автосписание</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.turn_autopayment ? 'Да' : 'Нет'}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Имя сотрудника</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.worker_name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Место работы</v-list-item-subtitle>
                  <v-list-item-title class="font-weight-medium">{{data.work_place}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-col>
        </v-row>
        <div class="text-right">
          <v-btn :width="$vuetify.breakpoint.smAndDown ? '100%' : null" color="primary" @click="$emit('apply')">Создать контракт</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {

    props: {
      value: Boolean,
      data: Object
    },
    methods: {
      close() {
        this.$emit('input', false)
      }
    }
  }
</script>
